import { jwtDecode } from 'jwt-decode';

export const PUNDIT_PUROHIT_USER_KEY = 'udyog_pp_user';
export const PUNDIT_PUROHIT_TOKEN_KEY = 'udyog_pp_token';
export const PUNDIT_PUROHIT_AUTH_SOURCE_KEY = 'udyog_auth_source';

const isUsableToken = (token) => {
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    return !decoded.exp || decoded.exp * 1000 > Date.now();
  } catch (error) {
    return false;
  }
};

export const getPunditPurohitToken = () => {
  const source = localStorage.getItem(PUNDIT_PUROHIT_AUTH_SOURCE_KEY);
  const ucToken = localStorage.getItem('token');
  const ppToken = localStorage.getItem(PUNDIT_PUROHIT_TOKEN_KEY);
  if (source === 'udyog_connect') return isUsableToken(ucToken) ? ucToken : null;
  if (source === 'pundit_purohit') return isUsableToken(ppToken) ? ppToken : null;
  if (isUsableToken(ppToken)) return ppToken;
  return isUsableToken(ucToken) ? ucToken : null;
};

export const getPunditPurohitAuthHeaders = () => {
  const token = getPunditPurohitToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getStoredPunditPurohitUser = () => {
  const token = getPunditPurohitToken();
  const savedUser = localStorage.getItem(PUNDIT_PUROHIT_USER_KEY);
  if (!token) return null;
  if (savedUser) return JSON.parse(savedUser);
  try {
    const decoded = jwtDecode(token);
    if (!decoded?.email || (decoded.exp && decoded.exp * 1000 <= Date.now())) return null;
    return {
      id: decoded.id,
      name: decoded.userfirstname || decoded.email.split('@')[0],
      email: decoded.email,
      mobile: decoded.mobile || '',
      source: decoded.source === 'pundit_purohit' ? 'pundit_purohit' : 'udyog_connect',
      role: 'devotee',
    };
  } catch (error) {
    return null;
  }
};

export const setStoredPunditPurohitUser = (user) => {
  localStorage.setItem(PUNDIT_PUROHIT_USER_KEY, JSON.stringify(user));
};

export const clearStoredPunditPurohitSession = () => {
  localStorage.removeItem(PUNDIT_PUROHIT_USER_KEY);
  localStorage.removeItem(PUNDIT_PUROHIT_TOKEN_KEY);
  localStorage.removeItem(PUNDIT_PUROHIT_AUTH_SOURCE_KEY);
};
